<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ຕິດຕາມຄວາມຄືບໜ້າຂອງສັນຍາ
          </h2>
        </div>
      </div>
      <b-field label="ຄົ້ນຫາສັນຍາ">
        <div class="columns">
          <div class="column">
            <b-field label="ແຂວງ">
              <Multiselect
                placeholder="ເລືອກ"
                v-model.trim="selectedProvince"
                label="NAME"
                track-by="ID"
                :options="provinceList"
                @input="onProvinceSelect"
              >
              </Multiselect>
            </b-field>
          </div>
          <div class="column">
            <b-field label="B2B">
              <Multiselect
                placeholder="ເລືອກ"
                v-model.trim="selectedB2B"
                label="B2BUSERNAME"
                track-by="B2BUSERNAME"
                :options="b2bList"
                @input="onB2BSelect"
              >
              </Multiselect>
            </b-field>
          </div>
          <div class="column">
            <b-field label="ເລກທີສັນຍາ">
              <Multiselect
                placeholder="ເລືອກ"
                v-model.trim="selectedContract"
                label="CONTRACTNO"
                track-by="CONTRACTNO"
                :options="contractList"
                @input="onContractSelect"
              >
              </Multiselect>
            </b-field>
          </div>
          <div class="column">
            <b-field label="ແຂວງຜະລິດ">
              <Multiselect
                placeholder="ເລືອກ"
                v-model.trim="selectedProduceProvince"
                label="NAME"
                track-by="ID"
                :options="produceProvinceList"
                @input="getSubContractbyProduceProvinceAndProduct"
              >
              </Multiselect>
            </b-field>
          </div>
          <div class="column">
            <b-field label="ສິນຄ້າ">
              <Multiselect
                placeholder="ເລືອກ"
                v-model.trim="selectedProduct"
                label="NAME"
                track-by="ID"
                :options="productList"
                @input="getSubContractbyProduceProvinceAndProduct"
              >
              </Multiselect>
            </b-field>
          </div>
        </div>
      </b-field>

      <b-field label="ລາຍການສັນຍາ">
        <table class="table is-fullwidth is-narrow is-small">
          <thead>
            <tr>
              <th class="has-text-centered " width="5%">#</th>
              <th class="has-text-centered " width="10%">
                ສັນຍາຍ່ອຍ
              </th>
              <th class="has-text-centered " width="10%">
                ສິນຄ້າ
              </th>
              <th class="has-text-centered " width="10%">
                ຈຳນວນ
              </th>
              <th class="has-text-centered " width="10%">
                ວັນທີຕ້ອງການ
              </th>
              <th class="has-text-centered " width="10%">
                ແຂວງຜະລິດ
              </th>
              <th class="has-text-centered " width="10%">
                ຊາວກະສິກອນ
              </th>
              <th class="has-text-centered " width="10%">
                ວັນຜະລິດ
              </th>
              <th class="has-text-centered " width="10%">
                ວັນເກັບກ່ຽວ
              </th>
              <th class="has-text-centered " width="10%">
                ສະຖານະ
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in subcontractList" :key="data.REQUESTID">
              <td class="has-text-centered">{{ index + 1 }}</td>

              <td class="has-text-centered">
                {{ data.SUBCONTRACTNO }}
              </td>
              <td class="has-text-centered">
                {{ data.PRODUCTNAME }}
              </td>

              <td class="has-text-centered">
                {{ data.AMOUNT | formatNumberLocal }}
              </td>

              <td class="has-text-centered">
                {{ dateFormatter(data.REDATE) }}
              </td>
              <td class="has-text-centered">
                <span v-if="data.PRODUCEPROVINCENAME == null">
                  {{  data.PROVINCENAME }}
                </span>
                <span v-else-if="data.PROVINCENAME === data.PRODUCEPROVINCENAME">
                  {{ data.PROVINCENAME }}
                </span>
                <span v-else>
                  {{  data.PRODUCEPROVINCENAME }}
                </span>
                
              </td>
              <td class="has-text-centered ">
                {{ data.NUMOFFARMER }}
              </td>
              <td class="has-text-centered">
                {{ data.PRODUCEDATE? dateFormatter(data.PRODUCEDATE) : '-' }}
              </td>
              <td class="has-text-centered">
                {{ data.HARVESTDATE? dateFormatter(data.HARVESTDATE) : '-' }}
              </td>

              <td class="has-text-centered">
                <!-- {{ data.REQSTATUS }} -- {{ data.STATUS }} -->
                <b-field
                  v-if="data.REQSTATUS ==4 && (data.STATUS == null ||data.STATUS == 1 || data.STATUS == 2)"
                  class="statusLabel-yellow"
                >
                  ລໍຖ້າຜະລິດ
                </b-field>
                <b-field v-else-if="data.STATUS == 3" class="statusLabel-pink">
                  ກຳລັງຜະລິດ
                </b-field>
                <b-field
                  v-else-if="data.STATUS == 4"
                  class="statusLabel-passed"
                >
                  ເກັບກ່ຽວແລ້ວ
                </b-field>
                <b-field
                  v-else-if="data.REQSTATUS ==2"
                  class="statusLabel-gray"
                >
                  ລໍຖ້າສົ່ງແຜນໃຫ້ສາຂາ
                </b-field>
                <b-field
                  v-else-if="data.REQSTATUS ==3"
                  class="statusLabel-little-gray"
                >
                  ລໍຖ້າສາຂາຮັບເອົາແຜນ
                </b-field>
                <b-field
                  v-else-if="data.REQSTATUS ==1"
                  class="statusLabel-little-gray"
                >
                  ລໍຖ້າຢືນຢັນແຜນ
                </b-field>
              </td>
            </tr>
          </tbody>
        </table>
      </b-field>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,
      provinceList: [],
      b2bList: [],
      contractList: [],
      subcontractList: [],
      produceProvinceList: [],
      productList: [],
      selectedProvince: null,
      selectedB2B: null,
      selectedContract: null,
      selectedProduceProvince: null,
      selectedProduct: null,
    };
  },
  methods: {
    getProvince() {
      RestAPI.getB2BProvince()
        .then((res) => {
          this.provinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onProvinceSelect() {
      RestAPI.getB2BList(this.selectedProvince.ID)
        .then((res) => {
          this.b2bList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onB2BSelect() {
      RestAPI.getContractList(
        this.selectedProvince.ID,
        this.selectedB2B.B2BUSERNAME
      )
        .then((res) => {
          this.contractList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    onContractSelect() {
      RestAPI.getSubContract(
        this.selectedProvince.ID,
        this.selectedB2B.B2BUSERNAME,
        this.selectedContract.CONTRACTNO
      )
        .then((res) => {
          this.subcontractList = res.data.subcontract;
          this.produceProvinceList = res.data.produceprovince;
          this.productList = res.data.product;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // onProduceProvinceSelect() {
    //   this.getSubContractDetailbyProduceProvince();
    // },

    // onProductSelect() {
    //   // if (this.selectedProduceProvince && this.selectedProduct) {
    //   //   RestAPI.getSubContractbyProduceProvinceAndProduct(
    //   //     this.selectedProvince.ID,
    //   //     this.selectedB2B.B2BUSERNAME,
    //   //     this.selectedContract.CONTRACTNO,
    //   //     this.selectedProduceProvince.ID,
    //   //     this.selectedProduct.ID
    //   //   )
    //   //     .then((res) => {
    //   //       this.subcontractList = res.data.subcontract;
    //   //       this.produceProvinceList = res.data.produceprovince;
    //   //       this.productList = res.data.product;
    //   //     })
    //   //     .catch((error) => {
    //   //       console.log(error);
    //   //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //   //     });
    //   // } else if (this.selectedProduceProvince) {
    //   this.getSubContractDetailbyProduct();
    //   // } else if (this.selectedProduct) {
    //   //   this.getSubContractDetailbyProduct();
    //   // }
    // },

    getSubContractbyProduceProvinceAndProduct() {
      var produceprovinceid;
      if (this.selectedProduceProvince) {
        produceprovinceid = this.selectedProduceProvince.ID;
      } else {
        produceprovinceid = 0;
      }

      var productid;
      if (this.selectedProduct) {
        productid = this.selectedProduct.ID;
      } else {
        productid = 0;
      }

      // console.log("produceprovinceid: " + produceprovinceid);

      // console.log(
      //   "selectedProduceProvince: " +
      //     JSON.stringify(this.selectedProduceProvince)
      // );

      RestAPI.getSubContractbyProduceProvinceAndProduct(
        this.selectedProvince.ID,
        this.selectedB2B.B2BUSERNAME,
        this.selectedContract.CONTRACTNO,
        produceprovinceid,
        productid
      )
        .then((res) => {
          this.subcontractList = res.data.subcontract;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // getSubContractDetailbyProduct() {
    //   var productid;
    //   if (this.selectedProduct) {
    //     productid = this.selectedProduct.ID;
    //   } else {
    //     productid = 0;
    //   }

    //   RestAPI.getSubContractbyProduct(
    //     this.selectedProvince.ID,
    //     this.selectedB2B.B2BUSERNAME,
    //     this.selectedContract.CONTRACTNO,
    //     productid
    //   )
    //     .then((res) => {
    //       this.subcontractList = res.data.subcontract;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getProvince();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.asterisk {
  color: red;
}
</style>
